import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/services/devsecops/page.tsx");
